import "./App.css";
import FAQ from "./components/FAQ";

function App() {
   return (
      <div className="App">
         <FAQ />
      </div>
   );
}

export default App;
